import type { CarProductItem } from "@/api/car";

interface CarCardProps {
  car: CarProductItem;
  isReplaceMode: boolean;
  onSelect: (id: number) => void;
}

export default function CarCard({ car, isReplaceMode, onSelect }: CarCardProps) {
  // 构建标签列表
  const tags = [
    car.service_type_text, // 含司机/自驾
    car.insurance_text,    // 全险
    car.deposit_type_text, // 免押金
  ].filter(Boolean);

  return (
    <div
      className="bg-white rounded-2xl overflow-hidden cursor-pointer active:scale-[0.99] transition-all"
      style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
      onClick={() => onSelect(car.id)}
    >
      {/* 车辆图片 */}
      <div className="w-full overflow-hidden" style={{ height: 130 }}>
        <img
          src={car.cover_url || car.cover_image}
          alt={car.title}
          className="w-full h-full object-cover object-center"
        />
      </div>
      {/* 车辆信息 */}
      <div className="p-3">
        <div className="text-sm font-bold text-gray-800 leading-snug">{car.title}</div>
        <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1 mt-1.5 text-xs text-gray-500">
          <span className="flex items-center gap-0.5">
            <i className="ri-user-line" style={{ fontSize: 11 }} />{car.seats_text}
          </span>
          <span className="flex items-center gap-0.5">
            <i className="ri-settings-2-line" style={{ fontSize: 11 }} />{car.gearbox_text}
          </span>
          {car.has_luxury_interior && (
            <span className="flex items-center gap-0.5">
              <i className="ri-star-line" style={{ fontSize: 11 }} />奢华内饰
            </span>
          )}
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-xs px-1.5 py-0.5 rounded-full" style={{ background: "#F0FDF4", color: "#15803D" }}>{tag}</span>
          ))}
        </div>
        <div className="flex items-end justify-between mt-2">
          <div>
            <span className="font-bold" style={{ color: "#EF4444", fontSize: 18 }}>{car.daily_price_text.replace("/天起", "")}</span>
            <span className="text-xs text-gray-400 ml-1">/天起</span>
          </div>
          {isReplaceMode ? (
            <button
              onClick={(e) => { e.stopPropagation(); onSelect(car.id); }}
              className="px-3 py-1.5 rounded-xl text-xs font-semibold text-white cursor-pointer whitespace-nowrap"
              style={{ background: "#FF6B35" }}
            >
              选择
            </button>
          ) : (
            <span className="text-xs flex items-center gap-0.5" style={{ color: "#1E3A8A" }}>
              查看详情<i className="ri-arrow-right-s-line" style={{ fontSize: 13 }} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
